import { Icon, Popover } from "@clarkinc/zest-design-system";
import React from "react";
import { EquivalentItem } from "./ProductDetailPageResult";
const equivalentItemPopoverId = "equivalent-item-popover-id";
interface Props {
  equivalentItems: EquivalentItem[];
}
const getDisplayText = (item: EquivalentItem) => {
  if (item.isVirtual && item.link) {
    return <a href={item.link}>{item.oemFull}</a>;
  }
  return item.oemFull;
};
const EquivalentItems = ({
  equivalentItems
}: Props) => {
  return <div className="parts-comp-table box padded" data-sentry-component="EquivalentItems" data-sentry-source-file="EquivalentItems.tsx">
      <h2 className="header-3 clears flex items-center">
        Equivalent Items
        <Popover data-sentry-element="Popover" data-sentry-source-file="EquivalentItems.tsx">
          <Popover.Trigger contentId={equivalentItemPopoverId} className="flex ml-1" data-sentry-element="unknown" data-sentry-source-file="EquivalentItems.tsx">
            <Icon name="ri-question-fill" aria-label="more information" size="xsmall" className="fill-green-500" data-sentry-element="Icon" data-sentry-source-file="EquivalentItems.tsx" />
          </Popover.Trigger>
          <Popover.Content id={equivalentItemPopoverId} title="Equivalent Items" placement="top" data-sentry-element="unknown" data-sentry-source-file="EquivalentItems.tsx">
            Equivalent items and any associated illustrations or descriptions
            are presented for your reference. These are items which, based on
            available manufacturer information, are comparable to the stated
            original item. These items are not necessarily authorized,
            sponsored, or endorsed by the manufacturer of the stated item, or by
            the manufacturers of equipment compatible with the stated item; any
            OEM names mentioned are registered trademarks.
          </Popover.Content>
        </Popover>
      </h2>
      <div className="parts-overflow">
        <table className="table table-stylized table-striped">
          <tbody data-testid="equivalent-items-table-body">
            {equivalentItems.map(item => <tr key={item.oemNum}>
                <td>{getDisplayText(item)}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
};
export default EquivalentItems;